<template>
  <div class="mt-3">
    <div class="header-purple">
      <div>
        <p class="mb-0">
          <strong>
            รายละเอียด
            <b-button
              v-if="collapseHeader"
              variant="link"
              size="sm"
              class="btn-collapse mb-1"
              @click="collapseHeader = false"
            >
              <b-icon icon="chevron-down"></b-icon>
            </b-button>
            <b-button
              v-if="!collapseHeader"
              variant="link"
              size="sm"
              class="btn-collapse mb-1"
              @click="collapseHeader = true"
            >
              <b-icon icon="chevron-up"></b-icon>
            </b-button>
          </strong>
        </p>
      </div>
    </div>
    <b-collapse v-model="collapseHeader" class="collapse-header">
      <div class="bg-white p-4">
        <b-form>
          <b-container class="p-0">
            <b-row>
              <b-col sm="6">
                <InputText
                  textFloat="ชื่อโปรโมชัน"
                  v-model="form.promotion.translationList[0].name"
                  isRequired
                  class="ml-1 mt-2"
                  placeholder="Name"
                  type="text"
                  :isValidate="
                    v.promotion.translationList.$each.$iter[0].name.$error
                  "
                  :v="v.promotion.translationList.$each.$iter[0].name"
                />
              </b-col>
              <b-col sm="6">
                <InputSelect
                  title="ประเภทโปรโมชัน"
                  name="type"
                  isRequired
                  class="select-type"
                  v-model="form.promotion.promotionTypeId"
                  v-bind:options="typeList"
                  valueField="value"
                  textField="text"
                  @onDataChange="changeTypePromotion"
                  :disabled="disabledType"
                />
              </b-col>
              <b-col sm="6">
                <InputText
                  textFloat="ลำดับ"
                  v-model="form.promotion.sortOrder"
                  isRequired
                  class="ml-1 mt-2"
                  placeholder="0"
                  type="number"
                  disableDot
                  :isValidate="v.promotion.sortOrder.$error"
                  :v="v.promotion.sortOrder"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <div class="ml-1 mt-2">
                  <div class="font-weight-bold">
                    วันที่ใช้งาน (เริ่มต้น) <span class="text-danger">*</span>
                  </div>
                  <div class="input-container">
                    <datetime
                      type="datetime"
                      :input-style="styleDatetime"
                      v-model="form.promotion.startDate"
                      placeholder="DD/MM/YYYY (HH:MM)"
                      format="dd/MM/yyyy (HH:mm)"
                      value-zone="Asia/Bangkok"
                      @close="changeStartDate"
                      ref="transferDateStart"
                      :isValidate="v.promotion.startDate.$error"
                      :v="v.promotion.startDate"
                      :disabled="id == 0 ? false : true"
                    >
                    </datetime>
                    <div
                      class="icon-container text-right"
                      @click="
                        $refs.transferDateStart.isOpen = id == 0 ? true : false
                      "
                    >
                      <font-awesome-icon
                        icon="calendar-alt"
                        class="pointer"
                        color="#B41BB4"
                      />
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col sm="6">
                <div class="ml-1 mt-2">
                  <div class="font-weight-bold">
                    วันที่ใช้งาน (สิ้นสุด) <span class="text-danger">*</span>
                  </div>
                  <div class="input-container">
                    <datetime
                      type="datetime"
                      :input-style="styleDatetime"
                      v-model="form.promotion.endDate"
                      placeholder="DD/MM/YYYY (HH:MM)"
                      format="dd/MM/yyyy (HH:mm)"
                      value-zone="Asia/Bangkok"
                      ref="transferDateEnd"
                      :min-datetime="form.promotion.startDate"
                      :isValidate="v.promotion.endDate.$error"
                      :v="v.promotion.endDate"
                    >
                    </datetime>
                    <div
                      class="icon-container text-right"
                      @click="$refs.transferDateEnd.isOpen = true"
                    >
                      <font-awesome-icon
                        icon="calendar-alt"
                        class="pointer"
                        color="#B41BB4"
                      />
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-row class="mt-5 ml-1">
                  <b-col sm="4">
                    <div class="mt-2">
                      <b-form-group>
                        <b-form-checkbox
                          class="mb-2"
                          v-model="form.promotion.useQuantity"
                          @change="
                            disabledQuantity = !$event;
                            form.promotion.quantity = 0;
                          "
                          >จำนวนการใช้งาน</b-form-checkbox
                        >
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col sm="8">
                    <InputText
                      textFloat=""
                      v-model="form.promotion.quantity"
                      class="ml-1 w-75"
                      :disabled="disabledQuantity"
                      placeholder="กรุณาใส่จำนวนที่ใช้ในโปรโมชัน"
                      type="number"
                      disableDot
                      :isValidate="v.promotion.quantity.$error"
                      :v="v.promotion.quantity"
                    />
                  </b-col>
                  <b-col sm="4">
                    <div class="mt-2">
                      <b-form-group>
                        <b-form-checkbox
                          class="mb-2"
                          v-model="form.promotion.isCouponCode"
                          @change="
                            disabledCoupon = !$event;
                            form.promotion.couponCode = '';
                          "
                          >ใช้เป็นคูปอง</b-form-checkbox
                        >
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col sm="8">
                    <InputText
                      textFloat=""
                      v-model="form.promotion.couponCode"
                      class="ml-1 w-75"
                      :disabled="disabledCoupon"
                      isRequired
                      placeholder="กรุณาใส่โค้ดที่ใช้ในโปรโมชัน"
                      type="text"
                      :isValidate="v.promotion.couponCode.$error"
                      :v="v.promotion.couponCode"
                    />
                  </b-col>
                  <b-col sm="12">
                    <div class="mt-2">
                      <b-form-group>
                        <b-form-checkbox
                          class="mb-2"
                          v-model="form.promotion.stopSequence"
                          >หยุดการทำงานหลังจากโปรโมชันนี้
                          <span class="text-sub"
                            >เช่น มีโปรโมชัน ซื้อ 1 แถม 1
                            จะไม่ร่วมกับโปรโมชันอื่นอีก</span
                          ></b-form-checkbox
                        >
                      </b-form-group>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col>
                    <div class="font-weight-bold">
                      สถานะการใช้งาน <span class="text-danger">*</span>
                    </div>
                    <b-form-checkbox
                      v-model="form.promotion.enabled"
                      class="mt-2"
                      name="check-button"
                      size="lg"
                      switch
                    >
                      <span class="text-default"
                        >ㅤ{{
                          form.promotion.enabled ? "เปิดใช้งาน" : "ปิดใช้งาน"
                        }}</span
                      >
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="6">
                <div class="mt-4 font-weight-bold">
                  ช่องทางการขาย <span class="text-danger">*</span>
                </div>
                <b-row class="mt-2 ml-1">
                  <b-col
                    sm="4"
                    v-for="(c, index) in sumChannelList"
                    :key="index"
                  >
                    <b-form-group>
                      <b-form-checkbox
                        class="mb-2"
                        :value="c.id"
                        v-model="form.branchList"
                        :disabled="
                          form.promotion.promotionTypeId == 6
                            ? c.disabled
                            : false
                        "
                        >{{ c.name }}</b-form-checkbox
                      >
                    </b-form-group>
                  </b-col>
                </b-row>
                <div class="text-danger" v-if="channelError">
                  กรุณาเลือกช่องทางการขาย
                </div>
              </b-col>
            </b-row>
          </b-container>
        </b-form>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import { BIcon } from "bootstrap-vue";
import * as moment from "moment/moment";
export default {
  // form.promotion.quantity
  name: "DetailPanel",
  components: { BIcon, InputText, InputSelect },
  props: {
    id: {
      type: Number,
      isRequired: true,
    },
    form: {
      type: Object,
      isRequired: true,
    },
    branchInBrand: {
      type: Array,
      isRequired: true,
    },
    ddotBranchInBrand: {
      type: Array,
      isRequired: true,
    },
    channelError: {
      type: Boolean,
      isRequired: true,
    },
    v: {
      type: Object,
      isRequired: true,
    },
  },
  data() {
    return {
      collapseHeader: true,
      typeList: [],
      isBusy: false,
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      disabledType: false,
      disabledQuantity: true,
      disabledCoupon: true,
      sumChannelList: [],
    };
  },
  // watch: {
  //   "form.promotion.quantity": {
  //     handler(val) {
  //       this.form.promotion.quantity = val.replace(/\./g,"");
  //     },
  //   },
  // },
  created: async function () {
    if (this.id != 0) {
      this.disabledType = true;
    }
    await this.setInit();

    await this.getPromotionType();
  },
  methods: {
    getPromotionType() {
      this.axios
        .get(`${this.$baseUrl}/promotion/promotionType`)
        .then((data) => {
          if (data.result == 1) {
            data.detail.forEach((d) => {
              this.typeList.push({ value: d.id, text: d.name });
            });
            if (this.id == 0) {
              this.form.promotion.promotionTypeId = this.typeList[0].value;
            }
          }
        });
    },
    async setInit() {
      this.disabledQuantity = !this.form.promotion.useQuantity;
      this.disabledCoupon = !this.form.promotion.isCouponCode;
      if (this.form.promotion.id == 0) {
        this.form.promotion.startDate = moment().format();
        this.form.promotion.endDate = moment().add("day", 1).format();
      }
      await this.ddotBranchInBrand.forEach((e) => {
        e.disabled = false;
      });
      await this.branchInBrand.forEach((e) => {
        e.disabled = true;
      });
      this.sumChannelList = this.ddotBranchInBrand.concat(this.branchInBrand);
    },
    changeTypePromotion(value) {
      this.$emit("changeTypePromotion", value);
    },
    changeStartDate() {
      if (this.form.promotion.startDate >= this.form.promotion.endDate) {
        this.form.promotion.endDate = moment(this.form.promotion.startDate)
          .add("day", 1)
          .format();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-collapse {
  color: #333333;
}
.select-type {
  margin-top: 7px !important;
}
::v-deep .btn-select {
  height: 42.4px;
  margin-top: 2px;
  color: #404040;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  padding: 9px 10px;
  cursor: pointer;
}
::v-deep .btn-select.custom-select-lg {
  height: 55px;
  font-size: 1rem;
}
::v-deep .btn-select:focus {
  border-color: #80c141;
}
::v-deep .btn-select > option {
  background-color: white;
  color: #16274a;
}
::v-deep .btn-select > option:checked {
  color: #16274a !important;
}
::v-deep .btn-select:focus {
  box-shadow: unset !important;
}
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
}
.icon-container {
  flex: 1 1 auto;
  cursor: text;
}
.text-sub {
  font-size: 14px;
  color: #bcbcbc;
}
.text-default {
  font-size: 16px;
}
</style>
